import React from 'react';
import {Controlled} from './Controlled.story';
import {DisabledReadOnly} from './DisabledReadOnly.story';
import {Invalid} from './Invalid.story';
import {Primary} from './Primary.story';
import {Size} from './Size.story';
import {Type} from './Type.story';
import {Uncontrolled} from './Uncontrolled.story';
import {Width} from './Width.story';

const basic = {
  rendered: <Primary />,
  source: `<TextField
  label="Business name"
  placeholder="Acme Inc…"
  uses={[
    css({
      width: css.value('168px'),
    }),
  ]}
/>`,
};

const type = {
  rendered: <Type />,
  source: `<View
  uses={[
    css({
      '& > *': {
        padding: css.value('8px 0'),
      },
    }),
  ]}
>
  <TextField label="Text" type="text" />
  <TextField label="Password" type="password" />
  <TextField label="Search" type="search" />
  <TextField label="Number" type="number" />
</View>`,
};

const size = {
  rendered: <Size />,
  source: `<View
  uses={[
    css({
      '& > *': {
        padding: css.value('8px 0'),
      },
    }),
  ]}
>
  <TextField label="Small" size="small" />
  <TextField label="Medium" size="medium" />
  <TextField label="Large" size="large" />
</View>`,
};

const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<TextField
  onChange={(e) => {
    console.log(e);
  }}
  label="First name"
/>`,
};

const width = {
  rendered: <Width />,
  source: `<TextField label="Age" css={{width: css.value('42px')}} />`,
};

const invalid = {
  rendered: <Invalid />,
  source: `<TextField label="Current year" defaultValue="1892" invalid />`,
};

const disabledReadOnly = {
  rendered: <DisabledReadOnly />,
  source: `<div>
  <View css={{paddingY: 'medium'}}>
    <TextField label="Disabled" defaultValue="Field is disabled" disabled />
  </View>
  <View css={{paddingY: 'medium'}}>
    <TextField label="Readonly" defaultValue="Field is readonly" readOnly />
  </View>
</div>`,
};

const controlled = {
  rendered: <Controlled />,
  source: `const [textValue, setTextValue] = React.useState<string>();
return (
  <TextField
    value={textValue}
    onChange={(e) => {
      setTextValue(e.target.value);
      // eslint-disable-next-line no-console
      console.log(e);
    }}
    label="First name"
  />
);`,
};

export const TextFieldExamples = {
  basic,
  controlled,
  uncontrolled,
  disabledReadOnly,
  invalid,
  width,
  size,
  type,
};
